import React, { Component } from "react";
import ResponsiveContainer from "recharts/lib/component/ResponsiveContainer";
import LineChart from "recharts/lib/chart/LineChart";
import Line from "recharts/lib/cartesian/Line";
import XAxis from "recharts/lib/cartesian/XAxis";
import YAxis from "recharts/lib/cartesian/YAxis";
import CartesianGrid from "recharts/lib/cartesian/CartesianGrid";
import Tooltip from "recharts/lib/component/Tooltip";
import Legend from "recharts/lib/component/Legend";
import  { Grid, Typography } from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";

const styles = theme => ({
    chartTitle: {
        textAlign: "center"
    }   
});

// const dataDaily = [
//     {name: "10.30", ACCOUNT: 10000, CARD: 0},
//     {name: "20.30", ACCOUNT: 0, CARD: 239},
//     {name: "45.21", ACCOUNT: 0, CARD: 4300},
//     {name: "35.00", ACCOUNT: 4780, CARD: 0},
//     {name: "98.00", ACCOUNT: 5890, CARD: 4800},
//     {name: "10.00", ACCOUNT: 4390, CARD: 0},
//     {name: "12.00", ACCOUNT: 0, CARD: 0},
// ];
// const dataWeek = [
//     {name: "Mon", Visits: 10000, Orders: 3400, aaa: 30430},
//     {name: "Tue", Visits: 1280, Orders: 2398, aaa: 3020},
//     {name: "Wed", Visits: 5000, Orders: 4300, aaa: 3100},
//     {name: "Thu", Visits: 4780, Orders: 2908, aaa: 30450},
//     {name: "Fri", Visits: 5890, Orders: 4800, aaa: 3070},
//     {name: "Sat", Visits: 4390, Orders: 3800, aaa: 3800},
//     {name: "Sun", Visits: 4490, Orders: 4300, aaa: 3800},
// ];


// function Daily() {
//     return (
//         <ResponsiveContainer width="99%" height={260}>
//             <LineChart data={dataDaily}>
//                 <XAxis dataKey="name"/>
//                 <YAxis/>
//                 <CartesianGrid vertical={false} strokeDasharray="3 3"/>
//                 <Tooltip/>
//                 <Legend/>
//                 <Line type="monotone" dataKey="ACCOUNT" stroke="#82ca9d"/>
//                 <Line type="monotone" dataKey="CARD" stroke="#8884d8" activeDot={{r: 8}}/>
//             </LineChart>
            
//         </ResponsiveContainer>
//     );
// }

// function Week() {
//     return (
//         <ResponsiveContainer width="99%" height={260}>
//             <LineChart data={dataWeek}>
//                 <XAxis dataKey="name"/>
//                 <YAxis/>
//                 <CartesianGrid vertical={false} strokeDasharray="3 3"/>
//                 <Tooltip/>
//                 <Legend/>
//                 <Line type="monotone" dataKey="Visits" stroke="#82ca9d"/>
//                 <Line type="monotone" dataKey="Orders" stroke="#8884d8" activeDot={{r: 8}}/>
//                 <Line type="monotone" dataKey="aaa" stroke="#8594d3" activeDot={{r: 7}}/>
//             </LineChart>
            
//         </ResponsiveContainer>
//     );
// }

function Month(props) {
    return (
        <ResponsiveContainer width="99%" height={260}>
            <LineChart data={props.chartData}>
                <XAxis dataKey="name"/>
                <YAxis/>
                <CartesianGrid vertical={false} strokeDasharray="3 3"/>
                <Tooltip/>
                <Legend/>
                <Line type="monotone" dataKey="RedmoPoints" stroke="#16a085" activeDot={{r: 8}}/>
                <Line type="monotone" dataKey="Card" stroke="#27ae60" activeDot={{r: 8}}/>
                <Line type="monotone" dataKey="Point" stroke="#2980b9" activeDot={{r: 8}}/>
                <Line type="monotone" dataKey="NA" stroke="#8e44ad" activeDot={{r: 8}}/>
                <Line type="monotone" dataKey="Bank" stroke="#2c3e50" activeDot={{r: 8}}/>
                <Line type="monotone" dataKey="MerchantWallet" stroke="#e74c3c" activeDot={{r: 8}}/>
            </LineChart>
            
        </ResponsiveContainer>
    );
}


class transactionCharts extends Component {

    componentDidUpdate(){
    
    }

    render() {

        const { classes, monthChart } = this.props;

        return (
            <div>
                <Typography variant="h6" gutterBottom>
                    Transactions
                </Typography>
                
                <Grid container spacing={32} className={classes.chartTitle}>
                    {/* <Grid item xs  md> 
                <Typography variant="overline" gutterBottom>
                    Daily
                </Typography>
                <Daily />
            </Grid> */}
                    {/* <Grid item xs md>
                <Typography variant="overline" gutterBottom>
                    This Week
                </Typography>
                <Week />
            </Grid> */}
                    <Grid item xs md>
                        <Typography variant="overline" gutterBottom>
                    This Month
                        </Typography>
                        <Month chartData={monthChart} />
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default  withStyles(styles)(transactionCharts);
